<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<div
    role="group"
    class='agpr-layoutBlock'
    [ngClass]="{
        'agpr-layoutBlock--editing': editing,
        'agpr-layoutBlock--cannot-move': !block.canMove,
        'agpr-layoutBlock--disabled': !block.actionable,
        'agpr-layoutBlock--error': block.errors?.length
    }"
    tabindex="0"
    [attr.aria-label]="'Pagebuilder.block.label' | localize: { index: +blockPosition + 1, type: block.type?.label }"
    [attr.aria-describedby]="id + '_errors'"
    (click)="onAction('edit', $event)"
>
    @if (block.actionable) {
        @if (showMoveButtons && block.canMove) {
            <agpr-kebab-menu
                #moveContextMenu
                class="agpr-layoutBlock-contextMenu agpr-layoutBlock-contextButton agpr-layoutBlock-contextMenu--topLeft--outside"
                [id]="id + '_move'"
                [style]="buttonTypes.contextMenu"
                icon="fa-regular fa-arrows-up-down-left-right"
                [panelPositionX]="panelPositions.left"
                [disabled]="!block.canMoveUp && !block.canMoveDown"
                [options]="movingOptions"
                [showIcon]="true"
                [loading]="null"
                tooltip="PageBuilder.blockIcon.move"
                tooltipPosition="top"
                (panelShown)="onMenuOpened()"
            ></agpr-kebab-menu>
        }
        <ul
            role="menu"
            class="agpr-layoutBlock-contextMenu agpr-layoutBlock-contextMenu--topRight--outside"
            [attr.aria-label]="'PageBuilder.blockMenu.edit' | localize"
        >
            @if (block.canDuplicate) {
                <li role="menuitem">
                    <agpr-button
                        class="agpr-layoutBlock-contextButton agpr-layoutBlock-contextButton--topLeft"
                        [id]="id + '_duplicate'"
                        [style]="buttonTypes.contextMenu"
                        icon="fa-regular fa-duotone fa-clone"
                        tooltip="PageBuilder.briefings.blockIcon.duplicate"
                        tooltipPosition="top"
                        (click)="onAction('duplicate')"
                    ></agpr-button>
                </li>
            }
            @if (block.canEdit) {
                <li role="menuitem">
                    <agpr-button
                        class="agpr-layoutBlock-contextButton"
                        [id]="id + '_edit'"
                        [style]="buttonTypes.contextMenu"
                        icon="fa-regular fa-duotone fa-pen"
                        tooltip="PageBuilder.briefings.blockIcon.edit"
                        tooltipPosition="top"
                        (click)="onAction('edit')"
                    ></agpr-button>
                </li>
            }
            @if (block.canAddOrRemove) {
                <li role="menuitem">
                    <agpr-button
                        class="agpr-layoutBlock-contextButton agpr-layoutBlock-contextButton--topRight"
                        [id]="id + '_delete'"
                        [style]="buttonTypes.contextMenu"
                        icon="fa-regular fa-duotone fa-trash-can"
                        tooltip="PageBuilder.briefings.blockIcon.delete"
                        tooltipPosition="top"
                        (click)="onAction('delete')"
                    ></agpr-button>
                </li>
            }
        </ul>
        <ul
            #addToTop
            role="menu"
            class="agpr-layoutBlock-contextMenu agpr-layoutBlock-contextMenu--center-top"
            [ngClass]="{ 'agpr-layoutBlock-contextMenu--hidden': addBottomExpanded }"
            [attr.aria-label]="'PageBuilder.blockMenu.add' | localize"
            (mouseleave)="leaveContextMenu(addToTop, $event, true, 'agpr-layoutBlock')"
        >
            <li role="menuitem">
                @if (inlineAdderAdjustment) {
                    <agpr-kebab-menu
                        class="agpr-layoutBlock-contextButton agpr-layoutBlock-contextButton--topLeft agpr-layoutBlock-contextButton--topRight agpr-inline-addTop-button"
                        [id]="id + '_addTop_moreOptions'"
                        icon="fa-regular fa-duotone fa-plus"
                        [style]="buttonTypes.contextMenu"
                        [panelPositionX]="panelPositions.right"
                        [options]="optionsTop"
                        [showIcon]="true"
                        [loading]="null"
                        tooltip="PageBuilder.briefings.blockIcon.addBlock"
                        tooltipPosition="top"
                        ariaLabel="PageBuilder.briefings.blockIcon.addBlock.toTop"
                        [panelAlignCenter]="true"
                        [textAlignment]="actionMenuTextAlignment"
                    ></agpr-kebab-menu>
                }@else {
                    <agpr-button
                        [id]="id + '_addTop'"
                        class="agpr-layoutBlock-contextButton agpr-layoutBlock-contextButton--topLeft agpr-layoutBlock-contextButton--topRight agpr-inline-addTop-button"
                        icon="fa-regular fa-duotone fa-plus"
                        tooltip="PageBuilder.briefings.blockIcon.addBlock"
                        tooltipPosition="top"
                        ariaLabel="PageBuilder.briefings.blockIcon.addBlock.toTop"
                        [expanded]="addTopExpanded"
                        (click)="inlineAddToggle($event, null, 'agpr-layoutBlock')"
                        [style]="buttonTypes.contextMenu"
                    >
                    </agpr-button>
                    <div
                        class="agpr-layoutBlock-contextMenu-adderContainer"
                        (focusout)="leaveContextMenu(addToTop, $event, false, 'agpr-layoutBlock')"
                    >
                        <div class="agpr-layoutBlock-contextMenu-adder">
                            <label class="agpr-layoutBlock-contextMenu-adder-header">{{ 'PageBuilder.inlineAdder.components' | localize | uppercase }}</label>
                            <agpr-block-adder
                                [id]="id + '_above_' + blockAdderId"
                                [addAtPosition]="blockPosition"
                            ></agpr-block-adder>
                            @if (areLayoutBlocksAllowed) {
                                <label class="agpr-layoutBlock-contextMenu-adder-header agpr-layoutBlock-contextMenu-adder-header-layout">{{ 'PageBuilder.inlineAdder.layouts' | localize | uppercase }}</label>
                                <agpr-layout-block-adder
                                    [id]="id + '_above_' + blockAdderId + '_layout'"
                                    [addAtPosition]="blockPosition"
                                    [isInline]="true"
                                ></agpr-layout-block-adder>
                            }
                        </div>
                    </div>
                }
            </li>
        </ul>
        <ul
            #addToBottom
            role="menu"
            class="agpr-layoutBlock-contextMenu agpr-layoutBlock-contextMenu--center-bottom"
            [ngClass]="{'agpr-layoutBlock-contextMenu--hidden': addTopExpanded}"
            [attr.aria-label]="'PageBuilder.blockMenu.add' | localize"
            (mouseleave)="leaveContextMenu(addToBottom, $event, true, 'agpr-layoutBlock')"
        >
            <li role="menuitem">
                @if (inlineAdderAdjustment) {
                    <agpr-kebab-menu
                        class="agpr-layoutBlock-contextButton agpr-layoutBlock-contextButton--bottomLeft agpr-layoutBlock-contextButton--bottomRight"
                        [id]="id + '_addBottom_moreOptions'"
                        icon="fa-regular fa-duotone fa-plus"
                        [style]="buttonTypes.contextMenu"
                        [panelPositionX]="panelPositions.right"
                        [options]="optionsBottom"
                        [showIcon]="true"
                        [loading]="null"
                        tooltip="PageBuilder.briefings.blockIcon.addBlock"
                        tooltipPosition="top"
                        ariaLabel="PageBuilder.briefings.blockIcon.addBlock.toBottom"
                        [panelAlignCenter]="true"
                        [textAlignment]="actionMenuTextAlignment"
                    ></agpr-kebab-menu>
                }@else {
                    <agpr-button
                        class="agpr-layoutBlock-contextButton agpr-layoutBlock-contextButton--bottomLeft agpr-layoutBlock-contextButton--bottomRight agpr-inline-addTop-button"
                        [id]="id + '_addBottom'"
                        icon="fa-regular fa-duotone fa-plus"
                        tooltip="PageBuilder.briefings.blockIcon.addBlock"
                        tooltipPosition="bottom"
                        ariaLabel="PageBuilder.briefings.blockIcon.addBlock.toBottom"
                        [expanded]="addBottomExpanded"
                        (click)="inlineAddToggle($event, null, 'agpr-layoutBlock')"
                        [style]="buttonTypes.contextMenu"
                    >
                    </agpr-button>
                    <div class="agpr-layoutBlock-contextMenu-adderContainer">
                        <div
                            class="agpr-layoutBlock-contextMenu-adder"
                            (focusout)="leaveContextMenu(addToBottom, $event, false, 'agpr-layoutBlock')"
                        >
                            <label class="agpr-layoutBlock-contextMenu-adder-header">{{ 'PageBuilder.inlineAdder.components' | localize | uppercase }}</label>
                            <agpr-block-adder
                                [id]="id + '_below_' + blockAdderId"
                                [addAtPosition]="blockPositionBottom"
                                [hideBlockTypes]="['coverage_curator']"
                            ></agpr-block-adder>
                            @if (areLayoutBlocksAllowed) {
                                <label class="agpr-layoutBlock-contextMenu-adder-header agpr-layoutBlock-contextMenu-adder-header-layout">{{ 'PageBuilder.inlineAdder.layouts' | localize | uppercase }}</label>
                                <agpr-layout-block-adder
                                    [id]="id + '_below_' + blockAdderId + '_layout'"
                                    [addAtPosition]="blockPositionBottom"
                                    [isInline]="true"
                                ></agpr-layout-block-adder>
                            }
                        </div>
                    </div>
                }
            </li>
        </ul>
    }

    <div class="agpr-layoutBlock-banner">
        @if (block.blocks.length === 1) {
            <span class="fa-duotone fa-regular fa-rectangle" aria-hidden="true"></span>
        } @else if (block.blocks.length === 2) {
            <span class="fa-kit-duotone fa-agpr-columns-2" aria-hidden="true"></span>
        } @else if (block.blocks.length === 3) {
            <span class="fa-duotone fa-regular fa-columns-3" aria-hidden="true"></span>
        }
        <span>{{ ('PageBuilder.formField.layout.header.' + block.blocks.length + 'ColumnLayout') | localize }}</span>
        @if (showEmptySectionWarning) {
            <span
                class="fa-regular fa-circle-info agpr-layoutBlock-banner-infoIcon"
                aria-hidden="true"
                agprTooltip="PageBuilder.layoutBlock.emptySectionWarning.tooltip"
                tooltipPosition="top"
                [tooltipAllowsHtml]="true"
            ></span>
        }
    </div>

    @if (block.displayElement.styles?.['padding']?.paddingOption === true) {
        <div
            class="agpr-layoutBlock-container"
            [id]="id"
            [attr.data-blocktype]="dataBlockType"
            [style.background-color]="block.displayElement.styles?.['backgroundColor']"
            [style.padding-top]="block.displayElement.styles['padding'].topPadding + 'px'"
            [style.padding-right]="block.displayElement.styles['padding'].rightPadding + 'px'"
            [style.padding-bottom]="block.displayElement.styles['padding'].bottomPadding + 'px'"
            [style.padding-left]="block.displayElement.styles['padding'].leftPadding + 'px'"
            [style.gap]="block.displayElement.styles?.['columnSpacing'] + 'px'"
            [ngClass]="{'agpr-layoutBlock-container-noOverflow': !editing}"
            [ngStyle]="{
                'border-top-left-radius': block.displayElement?.styles?.cornerRadius?.cornerRadiusOption
                    ? (block.displayElement?.styles?.cornerRadius.topLeftCornerRadius) + 'px'
                    : (block.displayElement?.styles?.cornerRadius?.cornerRadiusAll || 0) + 'px',
                'border-top-right-radius': block.displayElement?.styles?.cornerRadius?.cornerRadiusOption
                    ? (block.displayElement?.styles?.cornerRadius.topRightCornerRadius) + 'px'
                    : (block.displayElement?.styles?.cornerRadius?.cornerRadiusAll || 0) + 'px',
                'border-bottom-left-radius': block.displayElement?.styles?.cornerRadius?.cornerRadiusOption
                    ? (block.displayElement?.styles?.cornerRadius.bottomLeftCornerRadius) + 'px'
                    : (block.displayElement?.styles?.cornerRadius?.cornerRadiusAll || 0) + 'px',
                'border-bottom-right-radius': block.displayElement?.styles?.cornerRadius?.cornerRadiusOption
                    ? (block.displayElement?.styles?.cornerRadius.bottomRightCornerRadius) + 'px'
                    : (block.displayElement?.styles?.cornerRadius?.cornerRadiusAll || 0) + 'px'
            }"
        >
            <ng-container *ngTemplateOutlet="columnTemplate; context: { block: block, verticalAlignmentToAlignItemsMap: verticalAlignmentToAlignItemsMap }"></ng-container>
        </div>
    } @else {
        <div
            class="agpr-layoutBlock-container"
            [id]="id"
            [attr.data-blocktype]="dataBlockType"
            [style.background-color]="block.displayElement.styles?.['backgroundColor']"
            [style.padding]="block.displayElement.styles['padding'].paddingAll + 'px'"
            [style.gap]="block.displayElement.styles?.['columnSpacing'] + 'px'"
            [ngClass]="{'agpr-layoutBlock-container-noOverflow': !editing}"
            [ngStyle]="{
                'border-top-left-radius': block.displayElement?.styles?.cornerRadius?.cornerRadiusOption
                    ? (block.displayElement?.styles?.cornerRadius.topLeftCornerRadius) + 'px'
                    : (block.displayElement?.styles?.cornerRadius?.cornerRadiusAll || 0) + 'px',
                'border-top-right-radius': block.displayElement?.styles?.cornerRadius?.cornerRadiusOption
                    ? (block.displayElement?.styles?.cornerRadius.topRightCornerRadius) + 'px'
                    : (block.displayElement?.styles?.cornerRadius?.cornerRadiusAll || 0) + 'px',
                'border-bottom-left-radius': block.displayElement?.styles?.cornerRadius?.cornerRadiusOption
                    ? (block.displayElement?.styles?.cornerRadius.bottomLeftCornerRadius) + 'px'
                    : (block.displayElement?.styles?.cornerRadius?.cornerRadiusAll || 0) + 'px',
                'border-bottom-right-radius': block.displayElement?.styles?.cornerRadius?.cornerRadiusOption
                    ? (block.displayElement?.styles?.cornerRadius.bottomRightCornerRadius) + 'px'
                    : (block.displayElement?.styles?.cornerRadius?.cornerRadiusAll || 0) + 'px'
            }"
        >
            <ng-container *ngTemplateOutlet="columnTemplate; context: { block: block, verticalAlignmentToAlignItemsMap: verticalAlignmentToAlignItemsMap }"></ng-container>
        </div>
    }

    <ng-template #columnTemplate let-block="block" let-verticalAlignmentToAlignItemsMap="verticalAlignmentToAlignItemsMap">
        @for (column of block.blocks; track column; let i = $index;) {
            <div
                class="agpr-layoutBlock-column"
                [style.width]="block.displayElement.styles?.['width']?.[i]"
            >
                @if (column.length > 0) {
                    @if (disableDrop) {
                        <ul
                            class="agpr-layoutBlock-column-list"
                            [style.justify-content]="verticalAlignmentToAlignItemsMap.get(block.displayElement.styles?.['verticalAlignment'])"
                        >
                            <ng-container *ngTemplateOutlet="blockListTemplate; context: { column: column, block: block, blockPosition: blockPosition, columnIndex: i }"></ng-container>
                        </ul>
                    } @else {
                        <ul
                            class="agpr-layoutBlock-column-list"
                            [style.justify-content]="verticalAlignmentToAlignItemsMap.get(block.displayElement.styles?.['verticalAlignment'])"
                            [dndDropzone]="['block', 'blockType']"
                            dndEffectAllowed="copyMove"
                            (dndDrop)="onDropBlocks($event, i)"
                        >
                            <li
                                dndPlaceholderRef
                                class="agpr-drag-placeholder"
                            ></li>
                            <ng-container *ngTemplateOutlet="blockListTemplate; context: { column: column, block: block, blockPosition: blockPosition, columnIndex: i }"></ng-container>
                        </ul>
                    }
                    <ng-template #blockListTemplate let-column="column" let-blockPosition="blockPosition" let-block="block" let-i="columnIndex">
                        @for (blockModel of column; track blockModel; let j = $index;) {
                            <li
                                [dndDraggable]="j"
                                dndEffectAllowed="move"
                                dndType="block"
                                [dndDisableIf]="!block.draggable"
                                (dndStart)="onDragBlockStart(blockModel, blockPosition + '.' + i + '.' + j)"
                                (dndEnd)="onDragBlockComplete()"
                                (click)="preventPropagation($event)"

                            >
                                <agpr-block-wrapper
                                    [block]="blockModel"
                                    [blockPosition]="blockPosition + '.' + i + '.' + j"
                                    [isInLayoutBlock]="true"
                                    [isRightMost]="i === block.blocks.length - 1"
                                    [inlineAdderAdjustment]="inlineAdderAdjustment"
                                    [actionMenuTextAlignment]="actionMenuTextAlignment"
                                ></agpr-block-wrapper>
                            </li>
                        }
                    </ng-template>
                } @else {
                    @if (disableDrop) {
                        <div
                            #addComponent
                            class="agpr-layoutBlock-placeholder agpr-layoutBlock-contextMenu"
                            [ngClass]="{ 'agpr-layoutBlock-placeholder--adderOpened': openedPlaceholderIndex === i }"
                            [style.height]="placeholderHeight + 'px'"
                            (click)="inlineAddToggle($event, null, 'agpr-layoutBlock', i)"
                            (mouseleave)="leaveContextMenu(addComponent, $event, true, 'agpr-layoutBlock')"
                        >
                            <ng-container *ngTemplateOutlet="blockPlaceholderTemplate; context: { index: i, id: id, blockPosition: blockPosition, buttonTypes: buttonTypes }"></ng-container>
                        </div>
                    } @else {
                        <div
                            #addComponent
                            class="agpr-layoutBlock-placeholder agpr-layoutBlock-contextMenu"
                            [ngClass]="{ 'agpr-layoutBlock-placeholder--adderOpened': openedPlaceholderIndex === i }"
                            [style.height]="placeholderHeight + 'px'"
                            [dndDropzone]="['block', 'blockType']"
                            dndEffectAllowed="copyMove"
                            dndDragoverClass="agpr-layoutBlock-placeholder--dragover"
                            (dndDrop)="onDropBlocks($event, i)"
                            (click)="inlineAddToggle($event, null, 'agpr-layoutBlock', i)"
                            (mouseleave)="leaveContextMenu(addComponent, $event, true, 'agpr-layoutBlock')"
                        >
                            <ng-container *ngTemplateOutlet="blockPlaceholderTemplate; context: { index: i, id: id, blockPosition: blockPosition, buttonTypes: buttonTypes }"></ng-container>
                        </div>
                    }
                    <ng-template #blockPlaceholderTemplate let-i="index" let-id="id" let-blockPosition="blockPosition" let-buttonTypes="buttonTypes">
                        <label class="agpr-layoutBlock-placeholder-header">{{ 'PageBuilder.layoutBlock.placeholder.label' | localize }}</label>
                        @if (inlineAdderAdjustment) {
                            <agpr-kebab-menu
                                class="agpr-layoutBlock-inlineAdder-icon"
                                [id]="id + '_addComponentButton_moreOptions'"
                                icon="fa-regular fa-duotone fa-square-plus"
                                [panelPositionX]="panelPositions.right"
                                [options]="optionsCenter"
                                [showIcon]="true"
                                [loading]="null"
                                [panelAlignCenter]="true"
                                [addAtPosition]="blockPosition + '.' + i + '.0'"
                                [textAlignment]="actionMenuTextAlignment"
                                [useScrollPanel]="true"
                            ></agpr-kebab-menu>
                        }@else {
                            <span class="agpr-layoutBlock-inlineAdder-icon fa-regular fa-duotone fa-square-plus" aria-hidden="true"></span>
                            <div class="agpr-layoutBlock-contextMenu-adderContainer">
                                <div
                                    #placeholderComponent
                                    class="agpr-layoutBlock-contextMenu-adder agpr-layoutBlock-contextMenu-adder--withinBlock"
                                    [style.top]="placeholderHeight - 2 + 'px'"
                                    (focusout)="leaveContextMenu(placeholderComponent, $event, false, 'agpr-layoutBlock')"
                                >
                                    <label class="agpr-layoutBlock-contextMenu-adder-header">{{ 'PageBuilder.inlineAdder.components' | localize | uppercase }}</label>
                                    <agpr-block-adder
                                        [id]="id + '_below_' + blockAdderId"
                                        [hideBlockTypes]="['coverage_curator']"
                                        [addAtPosition]="blockPosition + '.' + i + '.0'"
                                    ></agpr-block-adder>
                                    @if (areLayoutBlocksAllowed) {
                                        <label class="agpr-layoutBlock-contextMenu-adder-header agpr-layoutBlock-contextMenu-adder-header-layout">{{ 'PageBuilder.inlineAdder.layouts' | localize | uppercase }}</label>
                                        <agpr-layout-block-adder
                                            [id]="id + '_above_' + blockAdderId + '_layout'"
                                            [addAtPosition]="blockPosition + '.' + i + '.0'"
                                            [isInline]="true"
                                            [disabled]="true"
                                        ></agpr-layout-block-adder>
                                    }
                                </div>
                            </div>
                        }
                    </ng-template>
                }
            </div>
        }
    </ng-template>

    <div class="agpr-layoutBlock-hoverBorder"></div>
</div>
<div [id]="id + '_errors'" *ngIf="block.errors?.length > 0" class="agpr-layoutBlockError">
    <agpr-form-message
        *ngFor="let error of block.errors"
    >
        {{ error | localize }}
    </agpr-form-message>
</div>
